// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "GifPlayer-module--cds--assistive-text--08d30";
export var cdsVisuallyHidden = "GifPlayer-module--cds--visually-hidden--c40a4";
export var container = "GifPlayer-module--container--3520a";
export var controls = "GifPlayer-module--controls--2ab11";
export var dark = "GifPlayer-module--dark--8c2f0";
export var gifDisplayed = "GifPlayer-module--gif-displayed--fd331";
export var gifHidden = "GifPlayer-module--gif-hidden--45e13";
export var gifInDialog = "GifPlayer-module--gif-in-dialog--3e62b";
export var hideFeedback = "GifPlayer-module--hide-feedback--0fca1";
export var imgDisplayed = "GifPlayer-module--img-displayed--16952";
export var imgHidden = "GifPlayer-module--img-hidden--d2801";
export var showFeedback = "GifPlayer-module--show-feedback--b2000";
export var skeleton = "GifPlayer-module--skeleton--9b322";